import React, { Component } from "react";
import { FaDownload } from "react-icons/fa";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import MetaTags from "react-meta-tags";
import { withRouter } from "react-router-dom";
import BootstrapTable from "react-bootstrap-table-next";
import ToolkitProvider, { Search } from "react-bootstrap-table2-toolkit";
import {
  Card,
  CardBody,
  Col,
  Container,
  Row,
  Alert,
  Modal,
  Input,
  ModalHeader,
  ModalBody,
  ModalFooter,
} from "reactstrap";

// Import Breadcrumb
import Breadcrumbs from "components/Common/Breadcrumb";

// Import actions
import { getParticipantSchemelist } from "store/Payment/actions";
import "assets/scss/table.scss";
import scheme from "pages/databaseadmin/scheme";

class PaymentSchemeList extends Component {
  constructor(props) {
    super(props);
    this.highlightPaymentId = new URLSearchParams(this.props.location.search).get("payment_id");
    this.state = {
      nameFilter: "",
      idFilter: "",
      selectedCheckboxes: {}, // Track checked checkboxes
      tableKey: 0,
      PaymentSchemeList: [],
      schemeModalOpen: false,
      feedbackMessage: "",
      originalPriceFilter: "",
      errorMessage: "", // State for error message
      cycleNumberFilter: "",
      priceFilter: "",
      discountFilter: "",
      paidAmountFilter: "",
      payDateFilter: "",
      paymentModeFilter: "",
      receivedByFilter: "",
      hoveredSchemeDetails: [],
      photoUrlFilter: "", // ✅ Add this line
      feedbackListColumns: [
       
        {
          dataField: "scheme_count",
          text: "Scheme",
          sort: true,
          headerStyle: {
            backgroundColor: "#87ceeb", // 🌤 sky blue for header
            textAlign: "center",
          },
          style: {
            backgroundColor: "#ade4faff",
            textAlign: "right",
          },
          headerFormatter: (column, colIndex) => (
            <div style={{ textAlign: "center" }}>
              <div>{column.text}</div>
              <div style={{ marginTop: "5px" }}>
                <input
                  type="text"
                  value={this.state.schemeFilter}
                  onChange={e => this.handleFilterChange("schemeFilter", e)}
                  className="form-control"
                  style={{
                    textAlign: "center",
                    width: "100px",
                    margin: "auto",
                  }}
                />
              </div>
            </div>
          ),
          formatter: (cell, row) => (
            <div
              onClick={() => this.handleSchemeClick(row)} // <- Changed to onClick
              style={{
                cursor: "pointer",
                textAlign: "center",
                color: "blue",
              }}
            >
              {cell}
            </div>
          ),
        },
         {
          text: "Payable",
          dataField: "price",
          sort: true,
           headerStyle: {
            backgroundColor: "#fff9c4",
            textAlign: "center",
          },
          style: {
            backgroundColor: "#fff9c4",
            textAlign: "right",
          },
          align: "right",
          headerFormatter: column => (
            <>
              <div>
                <div>{column.text}</div>
                <input
                  type="text"
                  value={this.state.originalPriceFilter}
                  onChange={e =>
                    this.handleFilterChange("originalPriceFilter", e)
                  }
                  className="form-control"
                />
              </div>
              
            </>
          ),
          formatter: cell => {
            if (cell === null || cell === undefined || cell === "") return "-";
            return new Intl.NumberFormat("en-US", {
              minimumFractionDigits: 2,
              maximumFractionDigits: 2,
            }).format(Number(cell));
          },
        },
        {
          text: "Discount / Tax",
          dataField: "discount_tax",
          sort: true,

          headerStyle: {
            backgroundColor: "#fff9c4",
            textAlign: "center",
          },
          style: {
            backgroundColor: "#fff9c4",
            textAlign: "center",
          },

          // Show discount and tax in same cell
         formatter: (cell, row) => {
  const discount = Number(row.discountAmount);
  const tax = Number(row.taxDeduction);

  return (
    <div>
      <div>{isNaN(discount) || discount === 0 ? "-" : discount.toLocaleString()}</div>
      <div>{isNaN(tax) || tax === 0 ? "-" : tax.toLocaleString()}</div>
    </div>
  );
}
,

          // Combined filter box (2 fields)
          headerFormatter: (column, colIndex) => (
            <div style={{ textAlign: "center" }}>
              <div>{column.text}</div>

              {/* Discount Filter */}
              <div style={{ marginTop: "5px" }}>
                <input
                  type="text"
                  value={this.state.discountFilter}
                  onChange={e => this.handleFilterChange("discountFilter", e)}
                  className="form-control"
                  style={{
                    textAlign: "center",
                    width: "100px",
                    margin: "auto",
                  }}
                />
              </div>

              {/* Tax Filter */}
            </div>
          ),
        },

        {
          dataField: "price",
          text: "Final Payable",
          sort: true,
          headerStyle: {
            backgroundColor: "#fff9c4",
            textAlign: "center",
          },
          style: {
            backgroundColor: "#fff9c4",
            textAlign: "right",
          },
          formatter: (cell, row) => {
            const price = parseFloat(row.price) || 0;
            const discount = parseFloat(row.discount) || 0;
            const tax = parseFloat(row.tax) || 0;

            const payable = price - discount - tax;
            return this.formatNumber(payable);
          },

          headerFormatter: (column, colIndex) => (
            <div style={{ textAlign: "center" }}>
              <div>{column.text}</div>
              <div style={{ marginTop: "5px" }}>
                <input
                  type="text"
                  value={this.state.finalpayableFilter}
                  onChange={e =>
                    this.handleFilterChange("finalpayableFilter", e)
                  }
                  className="form-control"
                  style={{
                    textAlign: "center",
                    width: "100px",
                    margin: "auto",
                  }}
                />
              </div>
            </div>
          ),
        },
      
{
  dataField: "paid_remaining",
  text: "Paid / Remaining",
  sort: false,

  headerStyle: {
    backgroundColor: "#d0e2ff",
    textAlign: "center",
  },
  style: {
    backgroundColor: "#d0e2ff",
    textAlign: "right",
  },

  // Cell Value (two lines)
  formatter: (cell, row) => (
    <div
      style={{ textAlign: "right", cursor: "pointer" }}
      title={`Paid: ${this.formatNumber(row.part_payment_amount)}\nRemaining: ${this.formatNumber(row.remaining_amount)}`}
    >
      <div>{this.formatNumber(row.part_payment_amount)}</div>
      <div>{this.formatNumber(row.remaining_amount)}</div>
    </div>
  ),

  /** HEADER WITH ONE FILTER BOX */
  headerFormatter: (column, colIndex) => (
    <div style={{ textAlign: "center" }}>
      <div>{column.text}</div>

      {/* One filter for both values */}
      <input
        type="text"
        placeholder="Search..."
        value={this.state.paidRemainingFilter}
        onChange={e => this.handleFilterChange("paidRemainingFilter", e)}
        className="form-control"
        style={{
          textAlign: "center",
          width: "100px",
          margin: "5px auto",
        }}
      />
    </div>
  ),
}

,
        {
          dataField: "payment_status",
          text: "Payment Status ",
          sort: true,
          headerStyle: {
            backgroundColor: "#d0e2ff", // 🔵 light blue for header
            textAlign: "center",
          },
          style: {
            backgroundColor: "#d0e2ff", // 🔵 light blue for cells
            textAlign: "right",
          },
          formatter: cell => (cell ? cell : "-"),

          headerFormatter: (column, colIndex) => (
            <div style={{ textAlign: "center" }}>
              <div>{column.text}</div>
              <div style={{ marginTop: "5px" }}>
                <input
                  type="text"
                  value={this.state.payment_status}
                  onChange={e =>
                    this.handleFilterChange("payment_status", e)
                  }
                  className="form-control"
                  style={{
                    textAlign: "center",
                    width: "100px",
                    margin: "auto",
                  }}
                />
              </div>
            </div>
          ),
        },
{
  text: "Pay Date",
  dataField: "paydate",
  sort: true,
  formatter: (cell, row) => {
    let dateToShow;

    // If payment is in process, show created_at
    if (row.payment_status === "Payment In process") {
      dateToShow = row.created_at;
    } else {
      dateToShow = cell; // actual pay date
    }

    if (!dateToShow) return "-";

    const dateObj = new Date(dateToShow);
    if (isNaN(dateObj)) return "-";

    const day = String(dateObj.getDate()).padStart(2, "0");
   const month = dateObj.toLocaleString("en-US", { month: "short" });
    const year = String(dateObj.getFullYear()).slice(-2); // last 2 digits of year

    return `${day}-${month}-${year}`;
  },
  headerFormatter: column => (
    <div>
      <div>{column.text}</div>
      <input
        type="text"
        value={this.state.payDateFilter}
        onChange={e => this.handleFilterChange("payDateFilter", e)}
        className="form-control"
      />
    </div>
  ),
}


,
        {
          dataField: "paymentmethod",
          text: "Payment Mode",
          sort: true,
          formatter: (cell, row) => {
            const receiptUrl = row.photo_url || null;
            const paymentMethod = row.paymentmethod || "-";

            return (
              <div className="d-flex justify-content-center align-items-center">
                {receiptUrl ? (
                  <a
                    href={receiptUrl}
                    download
                    className="d-flex align-items-center text-decoration-none"
                    target="_blank"
                    rel="noopener noreferrer"
                    title="Download Receipt"
                  >
                    <span className="me-2 text-primary">{paymentMethod}</span>
                    <FaDownload />
                  </a>
                ) : (
                  <span className="text-center">
                    {paymentMethod}{" "}
                    <span className="text-muted">(No Receipt)</span>
                  </span>
                )}
              </div>
            );
          },

          headerFormatter: (column, colIndex) => {
            return (
              
              <div style={{ textAlign: "center" }}>
                <div style={{ marginBottom: "5px" }}>
                   <div>{column.text}</div>
                  <input
                    type="text"
                    value={this.state.paymentModeFilter}
                    onChange={e =>
                      this.handleFilterChange("paymentModeFilter", e)
                    }
                    className="form-control"
                    style={{
                      textAlign: "center",
                      width: "100px",
                      margin: "auto",
                    }}
                  />
                </div>
               
              </div>
            );
          },
        },
        {
          text: "Received By",
          dataField: "receivedby",
          sort: true,
          headerFormatter: column => (
            <>
              <div>
                 <div>{column.text}</div>
                <input
                  type="text"
                  value={this.state.receivedByFilter}
                  onChange={e => this.handleFilterChange("receivedByFilter", e)}
                  className="form-control"
                />
              </div>
             
            </>
          ),
        },
      ],
    };
  }
  formatNumber = (value, options = {}) => {
    const num = Number(value);
    return !num || num === 0
      ? "-"
      : num.toLocaleString(undefined, {
          minimumFractionDigits: 0,
          maximumFractionDigits: 2,
          ...options,
        });
  };
  componentDidMount() {
    // Fetch data when the component mounts
    this.fetchData();
  }
componentDidUpdate(prevProps) {
  if (this.props.PaymentSchemeList !== prevProps.PaymentSchemeList) {
    console.log("PaymentSchemeList prop changed!", this.props.PaymentSchemeList);

    const paymentList = this.props.PaymentSchemeList;

    if (Array.isArray(paymentList) && paymentList.length > 0) {
      const transformedData = paymentList.map(payment => {
  // Determine paydate: use actual paydate, else created_at if in process
  let paydateValue = payment.paydate;
  if (!paydateValue && payment.payment_status === "Payment In process") {
    paydateValue = payment.created_at;
  }

  return {
    id: payment.id,
    participant_name: payment.participant_name || "-",
    district: payment.district || "-",
    membership_status: payment.membership_status || "-",
    scheme_count: payment.scheme_count || 1,
    scheme_names: payment.scheme_names || [],
    photo_url: payment.photo_url || payment.photo || "",
    attachment_url: payment.attachment_url || payment.attachment || "",
    scheme_ids: payment.scheme_ids || [],
    payment_reconcile_status: payment.payment_reconcile_status || "-",
    account_number: payment.account_number || "-",
    bank_name: payment.bank_name || payment.bank?.name || "-",
    added_by_name: payment.added_by_name || payment.added_by?.name || "-",
    reconciled_at: payment.reconciled_at || "-",
    price: payment.price || 0,
    discount: payment.discount || 0,
    discountAmount: payment.discountAmount || 0,
    taxDeduction: payment.taxDeduction || 0,
    part_payment_amount: payment.part_payment_amount || 0,
    priceBeforeDiscount: payment.priceBeforeDiscount || 0,
    purchase_order_copy: payment.purchase_order_copy || null,
    comments: payment.comments || "",
    payment_received_date: payment.payment_received_date || "-",
    payment_status_detail: payment.payment_status_detail || "-",
    payment_status: payment.payment_status || "-",
    paymentmethod: payment.paymentmethod || "-",
    receivedby: payment.receivedby || "-",
    organization_id: payment.organization_id || "-",
    payment_settlement: payment.payment_settlement || "-",
    account_id: payment.account_id || "-",
    cycle_id: payment.cycle_id || "-",
    participant_id: payment.participant_id || "-",
    paydate: paydateValue || "-",
    created_at: payment.created_at || "-",
    remaining_amount: payment.remaining_amount || "-",
    schemes: payment.schemes || [],
    table_id: `${payment.id}-${payment.cycle_id || 0}`, // optional unique key for table
  };
});


      console.log("Transformed PaymentSchemeList:", transformedData);

      this.setState(prevState => ({
        PaymentSchemeList: transformedData,
        tableKey: prevState.tableKey + 1,
      }));
    } else {
      this.setState({ PaymentSchemeList: [] });
    }
  }
}

  handleViewReconcileDetails = payment => {
    if (payment.payment_reconcile_status !== "Verified") {
      console.log("Modal not shown for Non-Verified status.");
      return; // Do nothing if the status is not "Verified"
    }

    console.log("Opening Verified Details for Payment:", payment);
    this.setState({
      showReconcileDetailsModal: true,
      selectedPayment: payment,
    });
  };
  handleCloseReconcileDetailsModal = () => {
    this.setState({
      showReconcileDetailsModal: false,
      selectedPayment: null,
    });
  };
handleSchemeClick = row => {
  if (this.mouseExitTimeout) {
    clearTimeout(this.mouseExitTimeout);
  }

  this.setState({
    selectedRow: row,  // <-- Save full row here
    hoveredSchemeDetails: row.schemes || [],
    schemeModalOpen: true,
    hoveredParticipantName: row.participant_name || "",
  });
};

  handleSchemeModalClose = () => {
    this.setState({
      schemeModalOpen: false,
    });
  };
  fetchData() {
    const { onGetParticipantPayment } = this.props;
    const PaymentSchemeId = this.props.match.params?.id; // Use optional chaining
    if (!PaymentSchemeId) {
      console.error("PaymentSchemeId not found in URL parameters");
    } else {
      console.log("Fetching data for ID:", PaymentSchemeId);
      onGetParticipantPayment(PaymentSchemeId);
    }
  }

handleFilterChange = (field, e) => {
  const value = e.target.value;

  this.setState({ [field]: value }, () => {
    const filtered = this.props.PaymentSchemeList.filter(item => {
      const paid = String(item.part_payment_amount || "");
      const remaining = String(item.remaining_amount || "");

      return (
        paid.includes(value) ||
        remaining.includes(value)
      );
    });

    this.setState({ PaymentSchemeList: filtered });
  });
};


filterData = () => {
  const {
    PaymentSchemeList,
    schemeFilter,
    originalPriceFilter,
    discountFilter,
    finalpayableFilter,
    paidamountFilter,
    payDateFilter,
    paymentModeFilter,
    receivedByFilter,
    payment_status,
  } = this.state;

  if (!Array.isArray(PaymentSchemeList)) return [];

  return PaymentSchemeList.filter(entry => {
    return (
      // Scheme Count
      entry.scheme_count?.toString().includes(schemeFilter || "") &&

      // Payable (price)
      entry.price?.toString().includes(originalPriceFilter || "") &&

      // Discount
      (entry.discountAmount?.toString() || "")
        .includes(discountFilter || "") &&
        
      (entry.price?.toString() || "")
        .includes(finalpayableFilter || "") &&
      // Paid Amount
      (entry.part_payment_amount?.toString() || "")
        .includes(paidamountFilter || "") &&

      // Pay Date / Created_at logic
      ((entry.paydate || entry.created_at || "")
        .toString()
        .includes(payDateFilter || "")) &&

      // Payment Mode
      (entry.paymentmethod || "")
        .toLowerCase()
        .includes((paymentModeFilter || "").toLowerCase()) &&

      // Payment Status
      (entry.payment_status || "")
        .toLowerCase()
        .includes((payment_status || "").toLowerCase()) &&

      // Received By
      (entry.receivedby || "")
        .toLowerCase()
        .includes((receivedByFilter || "").toLowerCase())
    );
  });
};



  render() {
    const { PaymentSchemeList } = this.state;
    console.log("Participant Scheme List", PaymentSchemeList);
    const defaultSorted = [{ dataField: "id", order: "desc" }];
    const pageOptions = {
      sizePerPage: 50,
      totalSize: PaymentSchemeList.length,
      custom: true,
    };
    return (
      <React.Fragment>
        <div className="page-content">
          <MetaTags>
            <title>Database Admin | Participants Scheme List</title>
          </MetaTags>
          <Container fluid>
            <h5 style={{ marginBottom: "20px" }}>
  {this.props.participant_name || "Unknown"} (
  {this.props.membership_status || "Inactive"})
</h5>


            <Row className="justify-content-center">
              <Col lg="12">
                <Card>
                  <CardBody>
                    <Modal
                      isOpen={this.state.schemeModalOpen}
                      toggle={this.handleSchemeModalClose}
                      onMouseEnter={() => clearTimeout(this.mouseExitTimeout)}
                      onMouseLeave={this.handleMouseExit}
                    >
                      <ModalHeader
                        toggle={this.handleSchemeModalClose}
                        tag="h4"
                      >
                        Purchased Schemes for{" "}
                        {this.state.hoveredParticipantName}
                      </ModalHeader>

                      <ModalBody>
                        <table className="table table-bordered">
                          <thead>
                            <tr>
                              <th style={{ textAlign: "center" }}>Scheme</th>
                              <th style={{ textAlign: "center" }}>Cycle</th>
                              <th style={{ textAlign: "center" }}>
                                Settlement
                              </th>
                              <th style={{ textAlign: "center" }}>Payment Status</th>
                            </tr>
                          </thead>

                        <tbody>
  {this.state.hoveredSchemeDetails.map((item, index) => (
    <tr key={index}>
      <td style={{ textAlign: "center" }}>
        {item.scheme_name}
      </td>

      <td style={{ textAlign: "center" }}>
        {item.cycle_no}
      </td>

      <td style={{ textAlign: "right" }}>
        {this.state.selectedRow?.payment_settlement || "-"}
      </td>
      <td style={{ textAlign: "right" }}>
        {this.state.selectedRow?.payment_status_detail || "-"}
      </td>
    </tr>
  ))}
</tbody>

                        </table>
                      </ModalBody>
                    </Modal>
                    <Modal
                      isOpen={this.state.showReconcileDetailsModal}
                      toggle={() =>
                        this.setState({
                          showReconcileDetailsModal: false,
                        })
                      }
                      centered
                    >
                      <ModalHeader
                        toggle={() =>
                          this.setState({
                            showReconcileDetailsModal: false,
                          })
                        }
                      >
                        Verification Details –{" "}
                        {this.state.selectedPayment?.participant_name}
                      </ModalHeader>

                      <ModalBody>
                        {this.state.selectedPayment ? (
                          <table className="table table-bordered table-striped">
                            <tbody>
                              <tr>
                                <td className="text-start">
                                  <strong>Status</strong>
                                </td>
                                <td className="text-start">
                                  {this.state.selectedPayment
                                    .payment_reconcile_status || "-"}
                                </td>
                              </tr>
                              <tr>
                                <td className="text-start">
                                  <strong>Account Number</strong>
                                </td>
                                <td className="text-start">
                                  {this.state.selectedPayment.account_number ||
                                    "-"}
                                </td>
                              </tr>
                              <tr>
                                <td className="text-start">
                                  <strong>Bank Name</strong>
                                </td>
                                <td className="text-start">
                                  {this.state.selectedPayment.bank_name || "-"}
                                </td>
                              </tr>
                              <tr>
                                <td className="text-start">
                                  <strong>Bank Credit Date</strong>
                                </td>
                                <td className="text-start">
                                  {this.state.selectedPayment
                                    .payment_received_date
                                    ? new Date(
                                        this.state.selectedPayment.payment_received_date
                                      ).toLocaleDateString("en-GB", {
                                        day: "2-digit",
                                        month: "short",
                                        year: "numeric",
                                      })
                                    : "-"}
                                </td>
                              </tr>
                              <tr>
                                <td className="text-start">
                                  <strong>Comments</strong>
                                </td>
                                <td className="text-start">
                                  {this.state.selectedPayment.comments || "-"}
                                </td>
                              </tr>
                              <tr>
                                <td className="text-start">
                                  <strong>Attachment</strong>
                                </td>
                                <td className="text-start">
                                  {this.state.selectedPayment
                                    ?.attachment_url ? (
                                    <a
                                      href={
                                        this.state.selectedPayment
                                          .attachment_url
                                      }
                                      target="_blank"
                                      rel="noopener noreferrer"
                                    >
                                      View Attachment
                                    </a>
                                  ) : (
                                    "-"
                                  )}
                                </td>
                              </tr>

                              <tr>
                                <td className="text-start">
                                  <strong>Verified By</strong>
                                </td>
                                <td className="text-start">
                                  {this.state.selectedPayment.added_by_name ||
                                    "-"}
                                </td>
                              </tr>
                              <tr>
                                <td className="text-start">
                                  <strong>Verified At</strong>
                                </td>
                                <td className="text-start">
                                  {this.state.selectedPayment.reconciled_at
                                    ? new Date(
                                        this.state.selectedPayment.reconciled_at
                                      ).toLocaleDateString("en-GB", {
                                        day: "numeric",
                                        month: "short",
                                        year: "numeric",
                                      })
                                    : "-"}
                                </td>
                              </tr>
                            </tbody>
                          </table>
                        ) : (
                          <p>No details found.</p>
                        )}
                      </ModalBody>
                    </Modal>

                    <ToolkitProvider
                      keyField="id"
                      columns={this.state.feedbackListColumns}
                     data={this.filterData()}
                      search
                    >
                      {toolkitprops => (
                        <React.Fragment>
                          <Row className="mb-4">
                            <Col xl="12">
                              <div className="table-responsive">
                                <style>
{`
  .highlight-payment-row td {
    background-color: #d8dadbff !important;
    color: #0f0e0eff !important;
    font-weight: bold !important;
  }
`}
</style>

                                 <BootstrapTable
      key={this.state.tableKey}
      keyField="id"
      {...toolkitprops.baseProps} // contains data and columns
      defaultSorted={defaultSorted}
      data={this.filterData()}   // 🔥 use filtered list!
      classes={"table align-middle"}
      bordered={false}
rowClasses={(row) =>
  String(row.id) === String(this.highlightPaymentId)
    ? "highlight-payment-row"
    : ""
}

      striped={false}
      headerWrapperClasses={"table-light"}
      responsive
    />
                              </div>
                              {/* Total Paid Amount */}
                              {/* <div className="mt-3 text-end">
                                <strong>Total Paid Amount: </strong>
                                {new Intl.NumberFormat("en-US", {
                                  minimumFractionDigits: 2,
                                  maximumFractionDigits: 2,
                                }).format(parseFloat(this.props.price) || 0)}
                              </div> */}
                            </Col>
                          </Row>
                        </React.Fragment>
                      )}
                    </ToolkitProvider>
                  </CardBody>
                </Card>
              </Col>
            </Row>
          </Container>
        </div>
      </React.Fragment>
    );
  }
}

PaymentSchemeList.propTypes = {
  match: PropTypes.object,
  participant_name: PropTypes.object,
  PaymentSchemeList: PropTypes.array,
  membership_status: PropTypes.string, // ✅ add this line
  history: PropTypes.object,
  // onGetSchemeAnalyte: PropTypes.func,
  onGetParticipantPayment: PropTypes.func,
  price: PropTypes.string,
  discount: PropTypes.string,
  paid_amount: PropTypes.string,
  pay_date: PropTypes.string,
  paymentmethod: PropTypes.string,
  receivedby: PropTypes.string,
  photo_url: PropTypes.string,
  original_price: PropTypes.string,
   location: PropTypes.shape({
    search: PropTypes.string,
  }),
};
const mapStateToProps = state => {
  const paymentSlice = state.AddPayment || {};
  const paymentList = paymentSlice.PaymentSchemeList || [];

  // Take first item to extract participant-level info
  const firstItem = paymentList[0] || {};

  // Extract all participant-level info dynamically
  const participantInfo = {
    participant_name: firstItem.participant_name || "Unknown",
    membership_status: firstItem.membership_status || "Inactive",
  };

  // Return props: participant info + full payment list
  return {
    PaymentSchemeList: paymentList,
    ...participantInfo,
  };
};

const mapDispatchToProps = (dispatch, ownProps) => ({
  onGetParticipantPayment: id => dispatch(getParticipantSchemelist(id)),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withRouter(PaymentSchemeList));
